const KEY = "lt_attribution";
const CONSENT = "lt_consent";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid"];

export function captureAttribution() {
  const p = new URLSearchParams(window.location.search);
  const hasNew = PARAMS.some((k) => p.get(k));
  if (sessionStorage.getItem(KEY) && !hasNew) return;
  const data = Object.fromEntries(PARAMS.map((k) => [k, p.get(k) || null]));
  data.landing_page = window.location.href.slice(0, 1000);
  data.referrer = document.referrer ? document.referrer.slice(0, 1000) : null;
  sessionStorage.setItem(KEY, JSON.stringify(data));
}

export const getAttribution = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch { return {}; }
};

export const getConsent = () => localStorage.getItem(CONSENT);
export function setConsent(v, settings) {
  localStorage.setItem(CONSENT, v);
  if (v === "granted") loadTags(settings);
}

let loaded = false;
export function loadTags(s) {
  if (loaded || getConsent() !== "granted" || !s) return;
  const ids = [s.ga4_id, s.google_ads_id].filter(Boolean);
  if (!ids.length) return;
  loaded = true;
  const el = document.createElement("script");
  el.async = true;
  el.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
  document.head.appendChild(el);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  ids.forEach((id) => window.gtag("config", id, { anonymize_ip: true }));
  window.__ltAds = s.google_ads_id ? { id: s.google_ads_id, labels: s.google_ads_labels || {} } : null;
}

// Never pass personal information in event params.
export function trackEvent(name, params = {}) {
  if (!window.gtag) return;
  window.gtag("event", name, params);
  const ads = window.__ltAds;
  if (ads && ads.labels?.[name]) window.gtag("event", "conversion", { send_to: `${ads.id}/${ads.labels[name]}`, ...params });
}
